import script from "./StepsView.vue?vue&type=script&setup=true&lang=js"
export * from "./StepsView.vue?vue&type=script&setup=true&lang=js"

import "./StepsView.vue?vue&type=style&index=0&id=0a833b1c&lang=css"

const __exports__ = script;

export default __exports__